import { Theme } from "@mui/material";

export const modalStyles = {
  paper: {
    borderRadius: 12,
    padding: 0,
    overflow: "hidden",
  },
  header: function (theme: Theme) {
    return {
      background: "linear-gradient(90deg, #93F090 0%, #60BFB7 100%)",
      color: "#fff",
      px: 3,
      py: 2,
      position: "relative",
    };
  },
  content: {
    px: 3,
    py: 2,
  },
  actions: {
    px: 3,
    py: 2,
    justifyContent: "flex-end" as const,
  },
};
